// extracted by css-extract-rspack-plugin
export default {"viewerDidAuthor":"CommentHeaderBadge-module__viewerDidAuthor__pV_fh"};